import {goToChannelViaAppScheme} from '@/components/starrank/mobile/StarRankMobileLayout';
import {convertViewCnt} from '@/utils/main';

/**
 * 별별랭킹 모바일 페이지, 스와이퍼 내부 아이템 정보(닉네임, 시청 수) 영역
 */
const StarRankMobileSwiperDetailMenu = ({rankItem}) => {
  return (
    <div className='details'>
      <a
        className='nick'
        onClick={() => goToChannelViaAppScheme(rankItem?.userId)}>
        <span>{rankItem?.userNick}</span>
      </a>
      <span className='views'>
        <em>{convertViewCnt(rankItem?.totalViewCnt)}명 참여중</em>
      </span>
    </div>
  );
};

export default StarRankMobileSwiperDetailMenu;
